export { default as qknColors } from './qknColors';

export const businessColorSequence = [
  'bizColor1',
  'bizColor2',
  'bizColor3',
  'bizColor4',
  'bizColor5',
  'bizColor6',
  'bizColor7',
  'bizColor8',
  'bizColor9',
  'bizColor10',
] as const;

export const businessColorReadable = Object.freeze({
  bizColor0: 'grey',
  bizColor1: 'sky',
  bizColor2: 'green',
  bizColor3: 'lime',
  bizColor4: 'yellow',
  bizColor5: 'cream',
  bizColor6: 'deepOrange',
  bizColor7: 'red',
  bizColor8: 'magenta',
  bizColor9: 'purple',
  bizColor10: 'blue',
});

export type BusinessColor = (typeof businessColorSequence)[number];
